import styled from "@emotion/styled";

export const LayoutWrapper = styled.main(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  position: theme?.breakpoints?.isMobile && "relative",
}));
